import cloneDeep from 'lodash/cloneDeep'
import { post } from 'axios'
// 上报前检查过滤不需要上报的数据
export default function(data) {
  if (!data || !data.events || !data.events.length) {
    return data
  }
  const events = cloneDeep(data.events).filter(item => {
    if (item.type == 'error' && item.message) {
      return !/^.*\(reading '.*'\)$/.test(item.message)
    }
    // 防止埋点监听
    if (item.type == 'xmlhttprequest' && item.name) {
      return ['https://mcs.volceapplog.com/list'].indexOf(item.name) == -1
    }
    return true
  })
  if (!events.length) {
    return false
  }
  return {
    ...data,
    events
  }
}

// 上报前检查过滤不需要上报的数据
export const eventFilterDataApi = (data, ignoreRuleList) => {
  if (!data || !data.events || !data.events.length) {
    return data
  }
  const events = cloneDeep(data.events).filter(item => {
    // 检查单个上报信息是否在忽略规则中。isAttrkeyRuleFn返回false表示不在规则中，可以上传
    return !ignoreRuleFilter(item, ignoreRuleList)
  })
  if (!events.length) {
    return false
  }
  return {
    ...data,
    events
  }
}
// 上报前检查过滤不需要上报的数据
export function filterSingeErr(errData, ignoreRuleList) {
  const isIgnoreRule = ignoreRuleFilter(errData, ignoreRuleList)
  return !isIgnoreRule
}

// 错误规则列表获取
export function getIgnoreRuleList(appCode) {
  /**
   * 数据格式大致为：
   * return [
      {
        id: '88fd2120-75a4-4c3a-a59f-b1072cc3436c',
        ruleName: '999',
        ruleCont: {
          message: {
            value: "Declaration missing '{'",
            valueSymbol: 'indexof',
          },
        },
        appCode: '10068',
      },
      {
        id: '88fd2120-75a4-4c3a-a59f-b1072cc3436c',
        ruleName: '1999',
        ruleCont: {
          message: {
            value: "Dxxxxx",
            valueSymbol: 'indexof',
          },
        },
        appCode: '10068',
      },
    ]
   * */

  return new Promise(resolve => {
    post(
      '/dst-lowcode-api/public/es/queryIndexDoc', // 接口在node6004服务低代码里
      {
        appCode,
        isEnable: true,
        andGlobal: true,
        isPage: false
      },
      {
        baseURL: '/dst-partner-apis'
      }
    )
      .then(res => {
        if (
          !res ||
          !res.data ||
          !res.data.data ||
          !res.data.data.list ||
          !res.data.data.list.length
        ) {
          resolve([])
          return
        }
        resolve(res.data.data.list.map(item => item.ruleCont))
      })
      .catch(() => {
        resolve([])
      })
  })
}
const isAttrkeyRuleFn = (RuleItem = {}, eventData) => {
  // 如果是空对象，则不符合
  if (!Object.keys(RuleItem).length) {
    return false
  }
  // eventData.type是阿里arms一定会有的字段
  if (RuleItem.type && RuleItem.type != eventData.type) {
    // 如果本条规则中用户有定义type的类型，先比较类型。不一样直接结束
    return false
  }
  if (!RuleItem.type && eventData.type != 'error') {
    // 如果本条规则中用户没有有定义type的类型，则默认是error类型。不是也直接结束
    return false
  }
  // 开始遍历规则的各字段
  for (const key in RuleItem) {
    if (!Object.hasOwnProperty.call(eventData, key)) {
      // 如果事件没有对应的key，则不符合
      return false
    }
    // 如果字段没有返回 或不是对象，则跳过，进入下个字段判断
    if (
      !RuleItem[key] ||
      Object.prototype.toString.call(RuleItem[key]) != '[object Object]'
    ) {
      return false
    }
    const value = RuleItem[key].value
    const valueSymbol = RuleItem[key].valueSymbol || '==='
    // const jsSymbol = {
    //   indexof: `'${eventData[key]}'.indexOf && '${
    //     eventData[key]
    //   }'.indexOf('${value}') != -1`,
    //   '===': `'${eventData[key]}' === '${value}'`,
    //   '!==': `'${eventData[key]}' !== '${value}'`,
    //   '>': `'${eventData[key]}' > '${value}'`,
    //   '<': `'${eventData[key]}' < '${value}'`,
    //   '>=': `'${eventData[key]}' >= '${value}'`,
    //   '<=': `'${eventData[key]}' <= '${value}'`
    // }[valueSymbol]
    console.log(valueSymbol, value, eventData[key])
    try {
      if (valueSymbol === '!==') {
        if (eventData[key] !== value) {
          continue
        } else {
          return false
        }
      } else if (valueSymbol === '>') {
        if (eventData[key] > value) {
          continue
        } else {
          return false
        }
      } else if (valueSymbol === '<') {
        if (eventData[key] < value) {
          continue
        } else {
          return false
        }
      } else if (valueSymbol === '>=') {
        if (eventData[key] < value) {
          continue
        } else {
          return false
        }
      } else if (valueSymbol === '<=') {
        if (eventData[key] <= value) {
          continue
        } else {
          return false
        }
      } else if (valueSymbol === 'indexof') {
        if (eventData[key].indexOf(value) !== -1) {
          continue
        } else {
          return false
        }
      } else {
        if (eventData[key] === value) {
          continue
        } else {
          return false
        }
      }
      // console.log('jsSymbol: ', jsSymbol)
      // const fnRun = new Function(`return ${jsSymbol}`)
      // if (fnRun()) {
      //   continue
      // } else {
      //   return false
      // }
    } catch (error) {
      console.log(error, 77777)
      // return false
    }
  }
  return true
}
// 根据规则查看当前事件是否符合条件
function ignoreRuleFilter(eventData, ignoreRuleList) {
  return ignoreRuleList.some(item => {
    // 检查单个上报信息是否在忽略规则中。isAttrkeyRuleFn返回false表示不在规则中，可以上传
    const res = isAttrkeyRuleFn(item, eventData)
    return !res
  })
}



// WEBPACK FOOTER //
// ./src/m-common/lib/armsRum/utils/eventFilterData.js